// Qt RGBA value
function rgbaToInt(r: number, g: number, b: number, a: number = 1.0) {
  if (r < 0 || r > 255) {
    throw new Error('r must be between 0 and 255');
  }
  if (g < 0 || g > 255) {
    throw new Error('g must be between 0 and 255');
  }
  if (b < 0 || b > 255) {
    throw new Error('b must be between 0 and 255');
  }
  if (a < 0.0 || a > 1.0) {
    throw new Error('a must be between 0.0 and 1.0');
  }

  const alphaInt = Math.round(a * 255);
  const colorInt = ((alphaInt & 0xff) << 24) | ((r & 0xff) << 16) | ((g & 0xff) << 8) | (b & 0xff);

  // Ensure sign is correct
  return colorInt >>> 0;
}

// Qt RGB value
function rgbToInt(r: number, g: number, b: number) {
  return rgbaToInt(r, g, b);
}

function intToRgba(colorInt: number) {
  if (colorInt < 0 || colorInt > 0xFFFFFFFF) {
    throw new Error('colorInt must be between 0 and 0xFFFFFFFF');
  }

  const alphaInt = (colorInt >> 24) & 0xff;
  const r = (colorInt >> 16) & 0xff;
  const g = (colorInt >> 8) & 0xff;
  const b = colorInt & 0xff;
  const a = alphaInt / 255;

  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

function parseRgbString(str: string) {
  const rgbaRegex = /^rgba?\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})(?:,\s*(0|1|0?\.\d+))?\)$/;
  const match = str.match(rgbaRegex);

  if (!match) {
    throw new Error('Invalid RGBA string format');
  }

  const r = parseInt(match[1] || '0', 10);
  const g = parseInt(match[2] || '0', 10);
  const b = parseInt(match[3] || '0', 10);
  const a = match[4] ? parseFloat(match[4]) : 1.0;

  if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255 || a < 0.0 || a > 1.0) {
    throw new Error('RGBA values out of range');
  }

  return { r, g, b, a };
}

function rgbToHex(r: number, g: number, b: number): string {
  const toHex = (n: number) => n.toString(16).padStart(2, '0').toUpperCase();
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}


export { rgbaToInt, rgbToInt, intToRgba, parseRgbString, rgbToHex };